<template>
  <p class="mr-6">Источник: Университет Джонса Хопкинса</p>
  <Multiselect
    class="select-country-analytic"
    label="text"
    :searchable="true"
    v-model="filter.year"
    valueProp="id"
    trackBy="text"
    noResultsText="Ничего не найдено."
    noOptionsText="Список пуст."
    :options="data.arrayOfYears"
    :canClear="false"
    placeholder="Период"
    @select="changeFilter"
  />
  <div>
    <SectionTitle text="Ключевые показатели" />
    <div class="wrapper d-flex align-items-center justify-content-between">
      <span>
        Новые случаи заражения COVID-19
        <br />
        <span class="count">
          {{ data.totalCountInfections ? data.totalCountInfections : 'Нет данных.' }}
        </span>
      </span>

      <span>
        Количество вакцинированных
        <br />
        <span class="count">
          {{ data.totalCountVaccinated ? data.totalCountVaccinated : 'Нет данных.' }}
        </span>
      </span>
    </div>
  </div>

  <EChartsLine v-if="!isLoading" :xData="data.arrayOfMonth" :series="getChartSeries" smoothLines valuePostfix=" тыс" />
</template>

<script>
  import Multiselect from '@vueform/multiselect';

  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';
  import Constants from '@/common/constants';

  import EChartsLine from '@/components/ChartComponents/apacheEcharts/EChartsLine.vue';

  import Api from '@/modules/importanalytics/api/healthcare.js';

  export default {
    name: 'Healthcare',
    components: {
      EChartsLine,
      Multiselect,
      SectionTitle,
    },
    props: {
      countryId: String,
    },
    data() {
      return {
        months: Constants.monthListSimple,
        page: {},
        request: {
          pageNumber: 1,
          pageSize: 24, //Два года
        },
        isLoading: false,
        filter: {},
        data: {
          totalCountInfections: null,
          arrayOfInfections: [],
          totalCountVaccinated: null,
          arrayOfVaccinated: [],
          arrayOfYears: null,
          arrayOfMonth: [],
        },
      };
    },
    computed: {
      getChartSeries() {
        return [
          {
            name: 'Новые случаи заражения COVID-19',
            data: this.data.arrayOfInfections,
            color: 'red',
          },
          {
            name: 'Количество вакцинированных',
            data: this.data.arrayOfVaccinated,
            color: '#30d5c8',
            fillArea: true,
          },
        ];
      },
    },
    methods: {
      initialLoadPage(append) {
        this.isLoading = !append;
        this.filter.countryId = this.countryId;
        var params = Object.assign(this.filter, this.request);
        Api.search(params)
          .then((response) => {
            if (!append) {
              this.page = response.data;
              this.page.items = this.page.items.sort((a, b) => {
                if (a.year != b.year) return a.year - b.year;
                if (a.month != b.month) return a.month - b.month;
              });
              // Собираем года
              this.data.arrayOfYears = response.data.items
                .map((x) => {
                  return { text: x.year, id: x.year };
                })
                // Фильтр на дубли
                .filter(
                  (value, index, self) => index === self.findIndex((t) => t.id === value.id && t.text === value.text),
                );
              // Собираем месяц + год
              // В массив для графика
              this.data.arrayOfMonth = response.data.items.map((x) => {
                return `${this.months[x.month - 1]} ${x.year}`;
              });
              // Собираем инфицированных
              // В массив для графика
              this.data.arrayOfInfections = response.data.items.map((x) => {
                return x.covidNewCaseCount / 1000;
              });
              // В сумму
              this.data.totalCountInfections = response.data.items
                .map((x) => {
                  return x.covidNewCaseCount;
                })
                .reduce((partialSum, a) => partialSum + a, 0);
              // Собираем вакцинированных
              // В массив для графика
              this.data.arrayOfVaccinated = response.data.items.map((x) => {
                return x.vaccinatedCount / 1000;
              });
              // // В сумму
              this.data.totalCountVaccinated = response.data.items
                .map((x) => {
                  return x.vaccinatedCount;
                })
                .reduce((partialSum, a) => partialSum + a, 0);
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
            this.$nextTick(() => {
              if (this.data.arrayOfYears.length) {
                this.filter.year = this.data.arrayOfYears[this.data.arrayOfYears.length - 1].id;
                this.changeFilter();
              }
            });
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      loadPage(append) {
        this.isLoading = !append;
        this.filter.countryId = this.countryId;
        var params = Object.assign(this.filter, this.request);
        Api.search(params)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
              // В массив для графика
              this.data.arrayOfMonth = response.data.items.map((x) => {
                return `${this.months[x.month - 1]} ${x.year}`;
              });
              // Собираем инфицированных
              // В массив для графика
              this.data.arrayOfInfections = response.data.items.map((x) => {
                return x.covidNewCaseCount / 1000;
              });
              // В сумму
              this.data.totalCountInfections = response.data.items
                .map((x) => {
                  return x.covidNewCaseCount;
                })
                .reduce((partialSum, a) => partialSum + a, 0);
              // Собираем вакцинированных
              // В массив для графика
              this.data.arrayOfVaccinated = response.data.items.map((x) => {
                return x.vaccinatedCount / 1000;
              });
              // // В сумму
              this.data.totalCountVaccinated = response.data.items
                .map((x) => {
                  return x.vaccinatedCount;
                })
                .reduce((partialSum, a) => partialSum + a, 0);
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      changeFilter() {
        this.request.pageNumber = 1;
        this.loadPage(false);
      },
    },
    created() {
      this.initialLoadPage();
    },
    watch: {
      countryId: function () {
        this.filter.year = null;
        this.initialLoadPage(false);
      },
    },
  };
</script>

<style scoped lang="scss">
  @import './src/assets/theme/default/colors';
  @import '../../styles/countryAnalyticsMultiselect.scss';
  .month {
    margin-top: 28px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &__item {
      cursor: pointer;
      padding: 8px 16px;
      font: $fira-12-M;
      font-style: normal;
      text-align: center;
      color: #c6c7c7;
      transition: 0.2s ease-in-out;
      border: 1px solid transparent;
      &:hover {
        color: $green;
      }
      &.active {
        color: #0193ba;
        border-radius: 4px;
        border-color: $colorGradient;
        border: 1px solid;
      }
    }
  }
  .select-country-analytic::v-deep {
    width: 150px !important;
    margin: 0;
    input:focus {
      border: unset;
      border-bottom: 1px solid $green;
    }
  }
  wrapper {
    max-width: 409px;
    span {
      max-width: 114px;
      font: $fira-12;
      font-style: normal;
      text-align: center;
      color: #333333;
    }
    .count {
      font-family: 'Fira Sans', sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      text-align: center;
      color: #333333;
    }
  }
</style>
